import { VisitaTareaSerie } from "./VisitaTareaSerie";

export class VisitaTarea {

    public idCompania : string;
    public idVisita : string;
    public idTarea : string;
    public tipoTarea : string;
    public numeroDocumento : string;
    public numeroOrden : string;
    public clasificacion : string;
    public codigo : string;
    public descripcion : string;
    public unidadMedida : string;
    public cantidad : number;
    public cantidadConfirmada : number;
    public peso : number;
    public volumen : number;
    public estadoTarea : string;
    public observaciones : string;
    public etiquetaContenedor: string;


    public bultos: number;
    public tipoBulto: string;
    public unidadBulto: number;


    public visitaTareaSeries: Array<VisitaTareaSerie>;
}